/**
 * 全局状态
 */
import { set_storage, get_storage } from "@/utils/util";
const langStorage = get_storage("currentLang");
const global = {
    namespaced: true,
    state: {
        //  ajax 请求 global.json 是否完成
        preloading: false,
        //  此处为true时意味着整个加载动画已经执行完毕, 并且已经消失
        preloadingDone: false,
        langloadingDone: false,
        //  存储调取api返回的schema
        schema: {},
        globalMenus: [],
        globalBasicInfo: null,
        //  用户访问语言
        currentLang: {
            lang: "",
        },
        routerName: "",
        isNewBeveliver: false,
    },
    mutations: {
        //  调用此方法时意味着 global.json 已加载完毕
        updatePreloading(state) {
            state.preloading = true;
        },
        //  调用此方法时意味着 加载动画已完成, 且完全消失
        updatePreloadingDone(state) {
            state.preloadingDone = true;
        },
        //  语言包加载完成
        updateLangloadingDone(state) {
            state.langloadingDone = true;
        },
        //  基础信息
        updateGlobalBasicInfo(state, basicInfo) {
            set_storage("user-role", basicInfo.roleName);
            state.globalBasicInfo = basicInfo;
            state.isNewBeveliver = basicInfo.roleName.includes("new-believer")
                ? true
                : false;

            //  预设语言，先读取localStorage 里的语言，如果没有，再用请求语言
            if (langStorage) {
                state.currentLang.lang = JSON.parse(langStorage).lang;
            } else if (basicInfo.roleName) {
                state.currentLang.lang = basicInfo.roleName.includes(
                    "new-believer"
                )
                    ? "en_US"
                    : "zh_TW";
            } else {
                state.currentLang.lang = "zh_TW";
            }
        },
        updateGlobalMenus(state, menus) {
            state.globalMenus = menus;
        },
        //  更新schema
        updateSchema(state, payload) {
            state.schema[payload.name] = payload.value;
        },
        //  更新用户访问语言, 默认为中文
        updateAccessLang(state, langObject) {
            //  先储存起来 , 再读取
            set_storage("currentLang", JSON.stringify(langObject));
            let langStorage = get_storage("currentLang");
            state.currentLang = langStorage && JSON.parse(langStorage);
        },
    },

    getters: {
        globalMainMenu: (state) => state.globalMenus,
        globalBasicInfos: (state) => state.globalBasicInfo,
    },
};
export default global;
